<template>
  <div>
    <div v-if="lists && lists.length > 0">
      <el-table
        :data="lists" stripe border
        style="width: 100%">
        <el-table-column
          label="年份" prop="year" width="120" sortable>
        </el-table-column>
        <el-table-column
          prop="name" label="姓名" width="80" sortable>
        </el-table-column>
        <el-table-column
          prop="idCard" label="身份证" width="180" sortable>
        </el-table-column>
        <el-table-column
          prop="finished" label="完成课程(门)" width="180" sortable>
        </el-table-column>
        <el-table-column
          prop="learned" label="获得学时" width="120" sortable>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="p">
            <el-button size="mini" type="primary" @click="getInvoice(p.row.id)">打印证书</el-button>
            <el-button size="mini" type="primary" @click="getStats(p.row)">课程明细</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <h5 class="none_ts" v-if="lists.length == '0'">
      <img src="@/assets/images/none_data.jpg" alt="">
    </h5>
    <!--<div class="zy_list_bottom">
      <dl>
        <dt v-if="lists.length > 0">共{{cnt}}条记录</dt>
        <dd v-if="lists.length >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>-->
  </div>
</template>
<script>
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import config from '@/config'
  import api from '@/api'
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: { Paginate },
    data () {
      return {
        lists: [{
          year: '2019',
          name: '高阳',
          idCard: '310108198206051234',
          finished: '12',
          un_finished: '15',
          learned: '5'
        }],
        pages: 0,
        cnt: 0,
        filters: {
          pageNo: 1,
          pageSize: 9,
          delFlag: '0',
          inBatchNo: '1'
        }
      }
    },
    created () {
      /* this.getLists(this.filters).then((r) => {
        this.cnt = r.cntData
        if (r) {
          this.lists = r.data
          this.pages = Math.ceil(this.cnt / this.filters.pageSize)
        } else {
          this.lists = []
          this.pages = 0
        }
      }) */
    },
    methods: {
      invoiceDateFormat: utils.invoiceDateFormat,
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.getLists(this.filters)
      },
      getStats (item) {
        let userid = getCookie(process.env.USERID_KEY).id
        let href = config.fineReportPath + '?reportlet=%5B7ee7%5D%5B7eed%5D%5B6559%5D%5B80b2%5D%2F%5B7ee7%5D%5B7eed%5D%5B6559%5D%5B80b2%5D%5B8bfe%5D%5B7a0b%5D%5B5b66%5D%5B4e60%5D%5B8be6%5D%5B60c5%5D.cpt&' + 'year=' + item.year + '&userId=' + userid
        console.log(href)
        window.open(href, '_blank')
      },
      getLists (filter) {
        return new Promise((resolve, reject) => {
          this.$api.post(this.$global.paymentApiPath, '/invoice/findList', filter, r => {
            resolve(r)
          })
        })
      },
      getInvoice (b_id) { // 获取发票
        this.$api.get(this.$global.paymentApiPath, '/invoice/getInvoiceAddress', {invoiceId: b_id}, r => {
          const a = document.createElement('a'); // 创建a标签
          a.setAttribute('download', '');// download属性
          a.setAttribute('href', r.data);// href链接
          a.setAttribute('target', '_blank'); // 打开新窗口
          a.click();// 自执行点击事件
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/modules/uc/learnrecord.vue